import React, { useState } from 'react';
import {Row, Col, Card, Button} from "react-bootstrap";
import SolutionService from "../../services/solution.service";
import { useUser } from "../../context/UserContext";
import AsaService from "../../services/asa.service";

const QuizTemplate = (data) => {


const questions = data.data;
const quizlength = questions.length;
const problemid = data.problem.problemid;
const ordernum = data.problem.ordernum;


const [currentQuestion, setCurrentQuestion] = useState(0)
const [showScore, setShowScore] = useState(false)
const [score, setScore] = useState(0)
const [errorSubmit, setErrorSubmit] = useState("");
const { asaData } = useUser();



const handleAnswerButtonClick = (isCorrect) => {
   if (isCorrect === true) {
   setScore(score + 1);
   }
     
   const nextQuestion = currentQuestion + 1;
   
   if (nextQuestion < quizlength) {
   setCurrentQuestion(nextQuestion);
   }
   else {
   setShowScore(true)
   }
}

const handleCompleteButtonClick = async () => {

   try {
     setErrorSubmit("");  
     const solid = await SolutionService.addSolutionByProblem(problemid, "Quiz Completed"); 
     setErrorSubmit("Task Completed! Refresh page to start the next task");   
     if(asaData){
      var datatosend = asaData;
      datatosend.step_number = ordernum + 1;
      const asaresp = await AsaService.sendTaskCompletion(datatosend);
      console.log("ASA Task Response: ", asaresp)
    } 
  } catch (errorSubmit) {  
     setErrorSubmit(errorSubmit.response?.data.message);
  }

};


return(
   <Card>
      <Card.Body>
         <Card.Title className='text-primary'>Quiz </Card.Title>
         
         <Card.Text>
            {showScore ? 
            (
               <>
                  <p className="my-2">
                    You scored <span className="fw-bold text-danger"> {score} out of {quizlength} </span>
                  </p>  
                  <p>
                     Here are the correct answers:
                  </p>
                     <ul>
                     {
                        questions.map((question) => (
                           <li>
                              {question.questionText}: <span className='fw-bold'> 
                                 {
                                    question.answerOptions.find((answer) => (answer.isCorrect)).answerText
                                 } </span> 
                           </li>

                        ))
                     }
                     </ul>
                     
                  
                  {errorSubmit && (
                           <p className="text-danger">
                           {errorSubmit}
                           </p>
                        )}  

                  {!errorSubmit && (
                     <Button className="m-1" variant="secondary" onClick={() => handleCompleteButtonClick()}>Complete Task</Button>
                  )}

                  
               </>
               
            )
            :
            (
               <>
               <p className="my-2"> <span className='fw-bold'>Question {currentQuestion + 1}</span> </p>
               <p className="mb-3"> <span> {questions[currentQuestion].questionText} </span></p>

               <p>
               {
                  questions[currentQuestion].answerOptions.map((answerOptions) => (
                  <Button className="m-1" variant="secondary" onClick={() => handleAnswerButtonClick(answerOptions.isCorrect)}>{answerOptions.answerText}</Button>
                  ))
               }
               </p>
               </>
            )
         }
         </Card.Text>
      </Card.Body>
      
   </Card>
);

}

export default QuizTemplate;